module.exports = __webpack_public_path__ + "static/sdg-interactions-79a3d17735b82b6c29c9213606e077b9.png";